import React from "react";
import { alpha, Box, Button, Stack, Typography, Chip, useMediaQuery, useTheme } from "@mui/material";
import { motion } from "framer-motion";
import { Add as AddIcon } from "@mui/icons-material";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";

const AMBER = "#d97706";
const AMBER_LIGHT = "#f59e0b";

const SimpleLabelHeader = ({ onAddLabel, onExport }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Box
        sx={{
          p: 2.5,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mb: 3,
          gap: 2,
          flexDirection: isMobile ? "column" : "row",
          background: `linear-gradient(135deg, ${alpha(AMBER, 0.04)} 0%, ${alpha(AMBER_LIGHT, 0.08)} 100%)`,
          borderRadius: 3,
          border: `1px solid ${alpha(AMBER, 0.1)}`,
        }}
      >
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={onAddLabel}
          sx={{
            minWidth: isMobile ? "100%" : "auto",
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 600,
            background: `linear-gradient(135deg, ${AMBER} 0%, ${AMBER_LIGHT} 100%)`,
            boxShadow: `0 4px 12px ${alpha(AMBER, 0.3)}`,
            "&:hover": {
              boxShadow: `0 6px 20px ${alpha(AMBER, 0.4)}`,
            },
          }}
        >
          Nova Etiqueta
        </Button>
      </Box>
    </motion.div>
  );
};

export default SimpleLabelHeader;
